import React from 'react';
import { Link } from 'react-router';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { RowItemDanhSachTheoDoiThucHien } from 'modules/theo-doi-thuc-hien/datatable';
import { Search } from './sub-view';
import { ThanhTra } from 'api';
import moment from 'moment';

class DanhSachTheoDoiThucHien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      search: false
    }
  }

  componentDidMount() {
    this.getDataList();
  }

  getDataList() {
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size
    }

    if (this.state.tenDoiTuongThanhTra) {
      params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
    }

    if (this.state.soQuyetDinh) {
      params.soQuyetDinh = this.state.soQuyetDinh;
    }

    if (this.state.linhVucThanhTra) {
      params.linhVucThanhTra = this.state.linhVucThanhTra;
    }

    if (this.state.tuNgay) {
      params.tuNgay = moment(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }

    if (this.state.denNgay) {
      params.denNgay = moment(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }

    ThanhTra.actions.getCuocThanhTraTheoDoi.request(null, params).then(res => {
     if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.cuocThanhTras,
          pageData: res.data.page,
          tableLoading: false,
          search: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false,
          search: false
        });
      }
    });
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getDataList();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getDataList();
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  openSearchForm() {
    this.setState({
      advanceSearch: true
    });
  }

  closeSearchForm() {
    this.setState({
      advanceSearch: false
    });

  }

  handleSearch(data) {
    if(this.validateSubmitForm()) {
      this.state = {
        ...this.state,
        ...data,
        search: true
      }
      this.setState({...this.state});
      this.getDataList();
    }
  }

  render() {
    return (
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-theo-doi"></i>Danh sách theo dõi thực hiện sau thanh tra/kiểm tra</p>
          </div>
        </div>
        <div className="bottom-content thanh-tra-search">
          <div className={ this.state.advanceSearch ? 'search-container super-search' : 'search-container' }>
            <Search ref="listSearch" advanceSearch={this.state.advanceSearch} bindValidator={this} onCancel={ this.closeSearchForm.bind(this) } handleSearch={ this.handleSearch.bind(this) } disabled={ this.state.searching } search={ this.state.search }/>
            <Link className="rearch-text" onClick={ this.openSearchForm.bind(this) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
          </div>
          <DataTable header={ header.theoDoiThucHien.danhSach } dataList={ this.state.data } hideExport pageData={ this.state.pageData } parent={ this } search={ this.state.search }
            tableLoading={ this.state.tableLoading }>
            <RowItemDanhSachTheoDoiThucHien/>
          </DataTable>
        </div>
      </div>
    );
  }
}

DanhSachTheoDoiThucHien.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default DanhSachTheoDoiThucHien;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/DanhSachTheoDoiThucHien.jsx